import React from 'react'
import RecordsBox from "../common/RecordsBox";
import InputBox from "./InputBox";

export default function Index(){
   return( <div className="row">
        <div className="col-xl-12">
          <RecordsBox  engine='bert'/>
        </div>
        <div className="col-xl-12">
          <InputBox engine='bert'></InputBox>
        </div>
      </div> )
}